<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs default-active-key="1" @change="handleTabChange">
        <!-- 服务工单 Tab -->
        <a-tab-pane key="1" tab="服务工单">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单号">
                    <a-input v-model="orderQueryParam.orderNo" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="客户电话">
                    <a-input v-model="orderQueryParam.receiverMobile" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="客户姓名">
                    <a-input v-model="orderQueryParam.receiverName" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单状态">
                    <a-select v-model="orderQueryParam.status" placeholder="请选择" allow-clear>
                      <a-select-option v-for="item in orderStatusOptions" :key="item.value">{{
                        item.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleOrderQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetOrderQuery"><a-icon type="redo" />重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <a-table
            :loading="orderLoading"
            :size="tableSize"
            rowKey="id"
            :columns="orderColumns"
            :data-source="orderList"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 1300 }"
            @change="onOrderSelectChange"
          >
            <span slot="status" slot-scope="text">
              <a-tag :color="getOrderStatusColor(text)">{{ getOrderStatusText(text) }}</a-tag>
            </span>
            <span slot="operation" slot-scope="text, record">
              <a
                v-if="record.status == 11"
                @click="$refs.assignMasterDrawer.show(record)"
                v-hasPermi="['upkeep:master:add']"
              >
                派单师傅
              </a>
              <a-divider type="vertical" v-hasPermi="['upkeep:order:query']" v-if="record.status == 11" />
              <a-dropdown v-hasPermi="['upkeep:order:query']">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['c4023b894a61205cceae45d003a05ff5b:0:b']">
                    <a @click="$refs.orderActionDrawer.open(record)">订单动作</a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['upkeep:order-merge:list']">
                    <a @click="$refs.orderMergeDrawer.open(record)">合并信息</a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['upkeep:order:query']">
                    <a @click="$refs.orderDetailDrawer.show(record)">详情</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="orderQueryParam.pageNum"
            :total="orderTotal"
            :page-size="orderQueryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onOrderShowSizeChange"
            @change="onOrderChangeSize"
          />
        </a-tab-pane>

        <!-- 工单客诉 Tab -->
        <a-tab-pane key="2" tab="工单客诉">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="投诉内容">
                    <a-input v-model="complaintQueryParam.name" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单号">
                    <a-input v-model="complaintQueryParam.code" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="排序方式">
                    <a-select
                      show-search
                      v-model="complaintQueryParam.sortOrder"
                      placeholder="请选择"
                      option-filter-prop="children"
                      :filter-option="filterOption"
                    >
                      <a-select-option key="ASCEND">升序</a-select-option>
                      <a-select-option key="DESCEND">降序</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleComplaintQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetComplaintQuery"
                      ><a-icon type="redo" />重置</a-button
                    >
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <a-table
            :loading="complaintLoading"
            :size="tableSize"
            rowKey="id"
            :columns="complaintColumns"
            :data-source="complaintList"
            :row-selection="{ selectedRowKeys: complaintSelectedRowKeys, onChange: onComplaintSelectChange }"
            :pagination="false"
            :bordered="tableBordered"
          >
            <span slot="status" slot-scope="text, record">
              <template>
                <a-popconfirm ok-text="是" cancel-text="否" @confirm="handleComplaintStatusType(record)">
                  <span slot="title"
                    >确认<b>{{ record.status === 0 ? '启用' : '停用' }}</b> {{ record.title }}的类型吗?</span
                  >
                  <a-switch checked-children="启用" un-checked-children="停用" :checked="record.status === 1" />
                </a-popconfirm>
              </template>
            </span>
            <span slot="scriptExplanation" slot-scope="text, record">
              <a-tooltip>
                <template slot="title">
                  <div v-html="record.scriptExplanation"></div>
                </template>
                <a> 查看 </a>
              </a-tooltip>
            </span>
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span slot="operation" slot-scope="text, record">
              <a
                @click="$refs.complaintCreateForm.handleUpdate(record, undefined)"
                v-hasPermi="['59e18ca9620651eac53131d056666a58c:0:c']"
              >
                接手处理
              </a>
              <a-divider type="vertical" v-hasPermi="['upkeep:script:remove']" />
              <a
                @click="$refs.complaintCreateForm.handleUpdate(record, undefined)"
                v-hasPermi="['59e18ca9620651eac53131d056666a58d:0:d']"
              >
                标记完毕
              </a>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="complaintQueryParam.pageNum"
            :total="complaintTotal"
            :page-size="complaintQueryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onComplaintShowSizeChange"
            @change="onComplaintChangeSize"
          />
        </a-tab-pane>

        <!-- 合并订单 Tab -->
        <a-tab-pane key="3" tab="合并工单">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" labelAlign="right">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单号">
                    <a-input v-model="mergeQueryParam.orderNo" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>

                <a-col :md="6" :sm="24">
                  <a-form-item label="需要合并的订单号">
                    <a-input v-model="mergeQueryParam.mergeOrderNo" placeholder="请输入" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleMergeQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetMergeQuery"><a-icon type="redo" />重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <a-table
            :loading="mergeLoading"
            :size="tableSize"
            rowKey="id"
            :columns="mergeColumns"
            :data-source="mergeList"
            :row-selection="{ selectedRowKeys: mergeSelectedRowKeys, onChange: onMergeSelectChange }"
            :pagination="false"
            :bordered="tableBordered"
          >
            <span slot="state" slot-scope="text, record">
              <a-tag :color="getMergeStateColor(record.state)">{{ getMergeStateText(record.state) }}</a-tag>
            </span>
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span slot="operation" slot-scope="text, record">
              <a @click="$refs.mergeDetailDrawer.open(record)" v-hasPermi="['upkeep:order-merge:query']">详情</a>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="mergeQueryParam.pageNum"
            :total="mergeTotal"
            :page-size="mergeQueryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            @showSizeChange="onMergeShowSizeChange"
            @change="onMergeChangeSize"
          />
        </a-tab-pane>
      </a-tabs>

      <!-- 服务工单相关组件 -->
      <AssignMasterDrawer ref="assignMasterDrawer" @success="getOrderList" />
      <OrderDetailDrawer ref="orderDetailDrawer" />
      <OrderMergeDrawer ref="orderMergeDrawer" />
      <OrderActionDrawer ref="orderActionDrawer" />

      <!-- 工单客诉相关组件 -->
      <ComplaintCreateForm
        ref="complaintCreateForm"
        :userList="complaintUserList"
        :statusOptions="complaintStatusOptions"
        @ok="getComplaintList"
      />

      <!-- 合并订单详情组件 -->
      <MergeDetailDrawer ref="mergeDetailDrawer" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList as fetchOrderList } from '@/api/repairModule/repairOrder'
import {
  fetchList as fetchComplaintList,
  statusObj as statusComplaintObj,
} from '@/api/maintenance/orderComplaint/index'
import { fetchList as fetchMergeList } from '@/api/maintenance/orderMerge/index'
import AssignMasterDrawer from './modules/AssignMasterDrawer'
import { tableMixin } from '@/store/table-mixin'
import OrderDetailDrawer from './modules/OrderDetailDrawer'
import OrderActionDrawer from './modules/OrderActionDrawer'
import OrderMergeDrawer from './modules/OrderMergeDrawer'
import ComplaintCreateForm from '../orderComplaint/modules/CreateForm'
import MergeDetailDrawer from '../orderMerge/modules/MergeDetailDrawer'

export default {
  name: 'RepairOrderList',
  components: {
    AssignMasterDrawer,
    OrderDetailDrawer,
    OrderMergeDrawer,
    OrderActionDrawer,
    ComplaintCreateForm,
    MergeDetailDrawer,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: { type: Boolean, default: true },
    tenantFirmId: { type: [String, Number], default: undefined },
    tenantId: { type: [String, Number], default: undefined },
  },
  data() {
    return {
      activeTab: '1',
      // 服务工单相关
      orderList: [],
      orderLoading: false,
      orderTotal: 0,
      orderQueryParam: { pageNum: 1, pageSize: 10 },
      orderColumns: [
        { title: '订单号', dataIndex: 'orderNo', width: 180, align: 'center' },
        { title: '产品名称', dataIndex: 'prodName', width: 180, align: 'center' },
        { title: '客户姓名', dataIndex: 'receiverName', width: 120, align: 'center' },
        { title: '客户电话', dataIndex: 'receiverMobile', width: 140, align: 'center' },
        { title: '客户地址', dataIndex: 'receiverDetailedAddress', width: 200, align: 'center' },
        {
          title: '订单状态',
          dataIndex: 'status',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '订单来源',
          dataIndex: 'orderSource',
          width: 120,
          align: 'center',
          customRender: (v) => this.orderSourceMap[v] || '-',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          width: 120,
          align: 'center',
          customRender: (v) => this.orderTypeMap[v] || '-',
        },
        { title: '预约时间', dataIndex: 'receiverUpTime', width: 160, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 160, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 180,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
      orderStatusOptions: [
        { value: 1, label: '已下单' },
        { value: 10, label: '待接单' },
        { value: 11, label: '派单中' },
        { value: 12, label: '转单中' },
        { value: 20, label: '等待上门' },
        { value: 21, label: '挂起工单' },
        { value: 22, label: '已上门' },
        { value: 23, label: '报价中' },
        { value: 24, label: '维修中' },
        { value: 30, label: '待付款' },
        { value: 40, label: '已完成' },
        { value: 50, label: '订单已取消' },
        { value: 51, label: '已合并订单' },
      ],
      orderSourceMap: { 0: '微信小程序', 1: 'APP', 2: '师傅下单' },
      orderTypeMap: { 0: '普通订单', 1: '合并订单(主)', 2: '合并订单(副)' },
      orderSelectedRowKeys: [],
      orderSelectedRows: [],
      // 工单客诉相关
      complaintList: [],
      complaintLoading: false,
      complaintTotal: 0,
      complaintQueryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
      },
      complaintColumns: [
        {
          title: '投诉订单',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '投诉内容',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '用户诉求',
          dataIndex: 'userAppeal',
          scopedSlots: { customRender: 'userAppeal' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '描述凭证',
          dataIndex: 'describeTheVoucher',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      complaintSelectedRowKeys: [],
      complaintSelectedRows: [],
      complaintUserList: [],
      complaintStatusOptions: [],
      // 合并订单相关
      mergeList: [],
      mergeLoading: false,
      mergeTotal: 0,
      mergeQueryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
      },
      mergeColumns: [
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '订单产品',
          dataIndex: 'orderProd',
          scopedSlots: { customRender: 'orderProd' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '需要合并的订单号',
          dataIndex: 'mergeOrderNo',
          scopedSlots: { customRender: 'mergeOrderNo' },
          ellipsis: true,
          align: 'center',
        },

        {
          title: '状态',
          dataIndex: 'state',
          ellipsis: true,
          scopedSlots: { customRender: 'state' },
          align: 'center',
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      mergeSelectedRowKeys: [],
      mergeSelectedRows: [],
    }
  },
  created() {
    if (!this.isOperate) {
      this.orderColumns.pop()
      this.complaintColumns.pop()
      this.mergeColumns.pop()
    }
    // 设置查询参数
    this.orderQueryParam.tenantFirmId = this.tenantFirmId
    this.orderQueryParam.tenantId = this.tenantId
    this.complaintQueryParam.tenantFirmId = this.tenantFirmId
    this.complaintQueryParam.tenantId = this.tenantId
    this.mergeQueryParam.tenantFirmId = this.tenantFirmId
    this.mergeQueryParam.tenantId = this.tenantId
    // 初始化状态选项
    this.complaintStatusOptions = this.dict.type['sys_enable_disable'] || []
    // 默认加载第一个 tab 的数据
    this.getOrderList()
  },
  methods: {
    handleTabChange(activeKey) {
      this.activeTab = activeKey
      // 切换 tab 时加载对应数据
      if (activeKey === '1' && this.orderList.length === 0) {
        this.getOrderList()
      } else if (activeKey === '2' && this.complaintList.length === 0) {
        this.getComplaintList()
      } else if (activeKey === '3' && this.mergeList.length === 0) {
        this.getMergeList()
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    parseTime(time) {
      if (!time) return ''
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    // 服务工单相关方法
    getOrderList() {
      this.orderLoading = true
      fetchOrderList(this.orderQueryParam)
        .then((response) => {
          this.orderList = response.data.records
          this.orderTotal = response.data.total
          this.orderLoading = false
        })
        .catch(() => {
          this.orderLoading = false
        })
    },
    getOrderStatusText(status) {
      const statusMap = {
        1: '已下单',
        10: '待接单',
        11: '派单中',
        12: '转单中',
        20: '等待上门',
        21: '挂起工单',
        22: '已上门',
        23: '报价中',
        24: '维修中',
        30: '待付款',
        40: '已完成',
        50: '已取消',
        51: '已合并',
      }
      return statusMap[status] || '-'
    },
    getOrderStatusColor(status) {
      const colorMap = {
        1: 'blue',
        10: 'orange',
        11: 'purple',
        12: 'cyan',
        20: 'gold',
        21: 'volcano',
        22: 'lime',
        23: 'green',
        24: 'green',
        30: 'red',
        40: 'green',
        50: 'gray',
        51: 'yellow',
      }
      return colorMap[status] || 'default'
    },
    handleOrderQuery() {
      this.orderQueryParam.pageNum = 1
      this.getOrderList()
    },
    resetOrderQuery() {
      this.orderQueryParam = { pageNum: 1, pageSize: 10, tenantFirmId: this.tenantFirmId, tenantId: this.tenantId }
      this.handleOrderQuery()
    },
    onOrderShowSizeChange(current, pageSize) {
      this.orderQueryParam.pageSize = pageSize
      this.getOrderList()
    },
    onOrderChangeSize(current, pageSize) {
      this.orderQueryParam.pageNum = current
      this.orderQueryParam.pageSize = pageSize
      this.getOrderList()
    },
    onOrderSelectChange(selectedRowKeys, selectedRows) {
      this.orderSelectedRowKeys = selectedRowKeys
      this.orderSelectedRows = selectedRows
    },
    // 工单客诉相关方法
    getComplaintList() {
      this.complaintLoading = true
      fetchComplaintList(this.complaintQueryParam)
        .then((response) => {
          this.complaintList = response.data.records
          this.complaintTotal = response.data.total
          this.complaintLoading = false
        })
        .catch(() => {
          this.complaintLoading = false
        })
    },
    handleComplaintQuery() {
      this.complaintQueryParam.pageNum = 1
      this.getComplaintList()
    },
    resetComplaintQuery() {
      this.complaintQueryParam = {
        pageNum: 1,
        pageSize: 10,
        tenantFirmId: this.tenantFirmId,
        tenantId: this.tenantId,
      }
      this.handleComplaintQuery()
    },
    onComplaintShowSizeChange(current, pageSize) {
      this.complaintQueryParam.pageSize = pageSize
      this.getComplaintList()
    },
    onComplaintChangeSize(current, pageSize) {
      this.complaintQueryParam.pageNum = current
      this.complaintQueryParam.pageSize = pageSize
      this.getComplaintList()
    },
    onComplaintSelectChange(selectedRowKeys, selectedRows) {
      this.complaintSelectedRowKeys = selectedRowKeys
      this.complaintSelectedRows = selectedRows
    },
    handleComplaintStatusType(row) {
      statusComplaintObj({ id: row.id })
        .then(() => {
          this.$message.success('操作成功！')
          this.getComplaintList()
        })
        .catch(function () {
          row.status = row.status === '0' ? '1' : '0'
        })
    },
    // 合并订单相关方法
    getMergeList() {
      this.mergeLoading = true
      fetchMergeList(this.mergeQueryParam)
        .then((response) => {
          this.mergeList = response.data.records
          this.mergeTotal = response.data.total
          this.mergeLoading = false
        })
        .catch(() => {
          this.mergeLoading = false
        })
    },
    handleMergeQuery() {
      this.mergeQueryParam.pageNum = 1
      this.getMergeList()
    },
    resetMergeQuery() {
      this.mergeQueryParam = {
        pageNum: 1,
        pageSize: 10,
        tenantFirmId: this.tenantFirmId,
        tenantId: this.tenantId,
      }
      this.handleMergeQuery()
    },
    onMergeShowSizeChange(current, pageSize) {
      this.mergeQueryParam.pageSize = pageSize
      this.getMergeList()
    },
    onMergeChangeSize(current, pageSize) {
      this.mergeQueryParam.pageNum = current
      this.mergeQueryParam.pageSize = pageSize
      this.getMergeList()
    },
    onMergeSelectChange(selectedRowKeys, selectedRows) {
      this.mergeSelectedRowKeys = selectedRowKeys
      this.mergeSelectedRows = selectedRows
    },
    getMergeStateText(state) {
      const stateMap = {
        0: '等待确认',
        1: '确认合并',
        2: '否合并订单',
        3: '超时取消合并',
      }
      return stateMap[state] || '-'
    },
    getMergeStateColor(state) {
      const colorMap = {
        0: 'orange',
        1: 'green',
        2: 'red',
        3: 'gray',
      }
      return colorMap[state] || 'default'
    },
  },
}
</script>
